import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { StaffingCompanyGroupRecord } from '../entities/records';
import * as selectors from '../entities/StaffingCompanyGroup/selectors';

function mapStateToProps(state, { staffingCompanyGroupId }) {
  return {
    staffingCompanyGroup: selectors.staffingCompanyGroupById(state, staffingCompanyGroupId),
  };
}

export default compose(
  setPropTypes({
    staffingCompanyGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    staffingCompanyGroup: PropTypes.instanceOf(StaffingCompanyGroupRecord),
  }),
)(mapStateToProps);
